import { GetTitlesResponse, TitleOption } from '../types';

export default ({ data }: GetTitlesResponse): TitleOption[] =>
  data.map(title => ({ label: title.attributes.label, value: title.id }));
